export default class CurativeRequirement {
    id: number;
    runsheetId: number;
    titleOpinionReqNo: string;
    reqDescription: string;
    statusId: number;
    assignedToId: number;
    dateAssigned: Date;
    curativeRemarks: string;
    isCompleted: boolean;
    briefDescription: string;
    curativeControlComments: string;
    statusName: string;
}


// WEBPACK FOOTER //
// ./src/models/CurativeRequirement.ts